exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ndiv.prism-editor-wrapper {\n    height: 300px;\n    overflow-y: auto;\n}\ndiv.prism-editor-wrapper * {\n    font-size:13px!important;\n}\n.height36 {\n    height:36px!important;\n}\n.width100 {\n    width:100%;\n}\n", ""]);

// exports
